import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Edit from './Edit';
import { eventPropType } from '../../Constants/eventTypes';

const EventSelectSecondary = ({
  confirm,
  back,
  show,
  valid,
  eventType,
  showAlert,
}) =>
  (show && (
    <>
      <Card.Header className="border-0">
        <div className="text-center w-100">
          <h1>
            Get your{' '}
            <span className="text-lowercase">{eventType.headerName}</span>{' '}
            insurance quote.
          </h1>
          {eventType.subtitle && (
            <div className="h7 pt-2">{eventType.subtitle}</div>
          )}
          <p>{eventType.eventCoverageNote}</p>
        </div>
      </Card.Header>
      <Card.Body>
        <Edit
          eventType={eventType}
          confirm={confirm}
          back={back}
          valid={valid}
          showAlert={showAlert}
        />
      </Card.Body>
    </>
  )) || <> </>;
EventSelectSecondary.propTypes = {
  confirm: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  eventType: eventPropType.isRequired,
  showAlert: PropTypes.bool.isRequired,
};

export default EventSelectSecondary;
